import { useMessages } from './useMessages';
import { TopPanel } from '../../components';
import { MessagesList } from './MessagesList';
import { Button, Input, Dropdown } from '../../components';

const Messages = () => {
  const {
    contacts,
    nodes,
    refresh,
    filters,
    setFilters,
    sending,
    selectedContact,
    chat,
    setChat,
    sendChat,
    reloading,
  } = useMessages();

  return (
    <div className="flex flex-col gap-y-md w-full">
      <TopPanel>
        {!!selectedContact && (
          <div className="mr-auto flex items-center font-medium text-big truncate">
            {[selectedContact.first_name, selectedContact.last_name]
              .filter(Boolean)
              .join(' ')}
          </div>
        )}
        <div>
          <Dropdown
            value={filters?.contactId}
            onChange={contactId => setFilters({ ...filters, contactId })}
            placeholder="Select a Contact"
            grow={false}
            options={contacts.map(contact => ({
              value: contact.id,
              label: contact.email,
            }))}
          />
        </div>

        <Button icon="refresh" loading={reloading} onClick={refresh}>
          Refresh
        </Button>
      </TopPanel>
      <MessagesList data={nodes} />
      <div className="flex gap-md items-center relative">
        <Input
          multiline
          rows={3}
          value={chat}
          onChange={setChat}
          disabled={!selectedContact || sending}
          placeholder="Type your message as a human representative..."
        />
        <Button
          icon="send"
          className="h-fit"
          loading={sending}
          onClick={sendChat}
          disabled={!chat.length || !selectedContact}
        />
      </div>
    </div>
  );
};

export default Messages;
